import React from "react"
import { Box, Container, Stack, StackDivider } from "@chakra-ui/react"

import { SectionProps, withSection } from "@app/hoc/Section"
import useNormaliseArticles from "@hooks/useNormaliseArticles"
import { ArticleColumnLarge, ArticleColumnProps, ArticleColumnSmall } from "./ArticleColumn"

export type ArticleColumnsProps = GatsbyTypes.SanitySectionArticleColumns & SectionProps

const ArticleColumns = ({ columns, theme, innerRef, handleTrackingClick }: ArticleColumnsProps) => {
  const { normaliseArticles } = useNormaliseArticles()

  const normalisedColumns: NormalisedArticleColumn[] =
    columns?.map(column => ({
      key: column?._key,
      title: column?.title,
      size: column?.size,
      articles: normaliseArticles(column?.articles as GatsbyTypes.SanityArticle[]),
    })) || []

  return (
    normalisedColumns?.length && (
      <Box ref={innerRef} bg={theme === "Dark" ? "brand.beige.dark" : "white"} py={6}>
        <Container>
          <Stack direction={["column", "row"]} alignItems="flex-start" spacing={2.5} divider={<StackDivider />}>
            {normalisedColumns?.map(column => {
              const props: ArticleColumnProps = { column, handleTrackingClick }
              return column.size === "large" ? (
                <ArticleColumnLarge key={column?.key} {...props} />
              ) : (
                <ArticleColumnSmall key={column?.key} {...props} />
              )
            })}
          </Stack>
        </Container>
      </Box>
    )
  )
}

export default React.memo(withSection(ArticleColumns))
